/**
 * Maps an i18next language code onto the locale name used by dayjs / moment.
 *
 * These are NOT always the same string. Simplified Chinese is registered as `zh`
 * in i18next (see `shared/constants/Languages`) to match this app's two-letter
 * locale convention, but both dayjs and moment ship it as `zh-cn` — moment has no
 * bare `zh` locale at all, and dayjs's `zh` is Traditional-leaning.
 *
 * This matters because `dayjs().locale('zh')` FAILS SILENTLY: dayjs keeps whatever
 * locale is currently active (English) instead of throwing, so dates would render
 * in English inside an otherwise fully Chinese UI with nothing in the console.
 */
const DATE_LIB_LOCALE_MAP: Record<string, string> = {
  // Traditional Chinese is intentionally not mapped: the app ships Simplified only,
  // and `convertDetectedLanguage` already collapses zh-TW/zh-HK onto `zh`.
  zh: 'zh-cn'
}

/**
 * Resolves the dayjs/moment locale name for an i18next language code.
 * Falls back to the bare language subtag, then to `en`.
 */
export const getDateLibLocale = (language?: string): string => {
  if (!language) return 'en'

  const normalized = language.toLowerCase()
  const base = normalized.split('-')[0]

  return DATE_LIB_LOCALE_MAP[normalized] ?? DATE_LIB_LOCALE_MAP[base] ?? base
}
